"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelayedOverlayWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
require("react-datepicker/src/stylesheets/datepicker.scss");
var components_1 = require("@athena-portal/components");
var journey_services_1 = require("@athena-portal/journey-services");
var journey_model_1 = require("@athena-portal/journey-model");
var DelayedOverlayWidget = exports.DelayedOverlayWidget = /** @class */ (function (_super) {
    __extends(DelayedOverlayWidget, _super);
    function DelayedOverlayWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.delay = _this.getSetting("delay", undefined);
        _this.navigateToUrl = _this.getSetting("navigateToUrl", "/dashboard");
        _this.state = {
            loading: true,
        };
        return _this;
    }
    DelayedOverlayWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.timerId = setTimeout(function () {
            _this.setState({ loading: false });
            window.location.href = journey_services_1.ExpressionEvaluator.renderTemplate(_this.navigateToUrl, _this.props.engine.getInteraction());
        }, this.delay);
    };
    DelayedOverlayWidget.prototype.componentWillUnmount = function () {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
    };
    DelayedOverlayWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(components_1.Overlay, { show: this.state.loading })));
    };
    DelayedOverlayWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "delay", type: journey_model_1.TypeDescriptions.Number },
            { name: "navigateToUrl", type: journey_model_1.TypeDescriptions.String }, // URL to navigate to after delay
        ]),
        __metadata("design:paramtypes", [Object])
    ], DelayedOverlayWidget);
    return DelayedOverlayWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=DelayedOverlayWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/DelayedOverlayWidget.js
// module id = 3660
// module chunks = 0